module.exports = "/assets/bd96c1d977ea54f5226925ea0ef74cbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/LJ.png
// module id = 1581
// module chunks = 0